export default __webpack_public_path__ + "static/media/churn_needs_video_paths.7cfccccd.gif";